import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Flex, Popup } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { ModelEditorFactory } from '@leverege/ui-plugin';
import SortModels from "../../../filters/sort/SortModels.js";
import AttributeSortFieldModel from "../../../filters/sort/AttributeSortFieldModel.js";
import AttributeSortModel from "../../../filters/sort/AttributeSortModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.dashboard.OrderEditor');
export default function OrderEditor(props) {
  const {
    eventData,
    value,
    onChange,
    sharedProps
  } = props;
  const {
    objectType,
    delegate,
    relationship
  } = sharedProps;
  const [opened, setOpened] = useState(false);
  const v = useMemo(() => {
    return value && typeof value === 'object' ? {
      ...value
    } : SortModels.getSortModelFor(delegate.type, `${objectType}.history`)?.create();
  }, [value, delegate.type, objectType]);
  const onPopupChange = useCallback(({
    isOpened
  }) => {
    setOpened(isOpened);
  }, [setOpened]);
  useEffect(() => {
    const onOpenSort = evt => {
      const {
        detail,
        type
      } = evt;
      const o = type.includes('.sortAsc') ? 'asc' : 'desc';
      const missing = o === 'asc' ? '_first' : '_last';
      const attrName = detail?.attrName;
      if (attrName) {
        const sort = AttributeSortFieldModel.create({
          order: o,
          missing,
          attrName
        });
        let nSortModel;
        if (v?.fields?.length === 1 && v.fields[0].attrName == null) {
          nSortModel = AttributeSortModel.setField(v, 0, sort);
        } else {
          nSortModel = AttributeSortModel.addField(v, sort);
        }
        onChange({
          data: eventData,
          value: nSortModel
        });
      }
      setOpened(true);
    };
    window.addEventListener(`molten.sortAsc.${objectType}.history.open`, onOpenSort);
    window.addEventListener(`molten.sortDesc.${objectType}.history.open`, onOpenSort);
    return () => {
      window.removeEventListener(`molten.sortAsc.${objectType}.history.open`, onOpenSort);
      window.removeEventListener(`molten.sortDesc.${objectType}.history.open`, onOpenSort);
    };
  }, [setOpened, v, objectType, eventData, onChange]);
  const editor = ModelEditorFactory.create(v, {
    context: {
      objectType: `${objectType}.history`
    },
    delegate,
    relationship,
    onChange,
    eventData
  });
  return /*#__PURE__*/_jsx(Flex, {
    variant: "rowM",
    align: "center",
    children: /*#__PURE__*/_jsx(Popup, {
      opened: opened,
      onChange: onPopupChange,
      variant: "filter",
      toggleVariant: "filter|sortFilterBar|actionBar",
      icon: tIcon('sortIcon', 'fa fa-fw fa-sort'),
      title: t('dashboardOrder'),
      children: editor
    })
  });
}
OrderEditor.TYPE = 'order';